function getNewId() {
    if (!window.lastGeneratedId) {
        window.lastGeneratedId = 0;
    }
    window.lastGeneratedId += 1;
    return window.lastGeneratedId;
};

export {
    getNewId
};
